var map = {
	"./feel-good/left.svg": [
		87,
		4
	],
	"./indulge-my-passions/left.svg": [
		88,
		8
	],
	"./keep-me-company/left.svg": [
		89,
		12
	],
	"./quick-news-fix/left.svg": [
		90,
		16
	],
	"./take-me-away/left.svg": [
		91,
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 38;
module.exports = webpackAsyncContext;